import { action, computed, makeObservable, observable } from "mobx";
import { DateTime } from "luxon";
import { ChildStore } from "./child.store";
import { RootStore } from "./root.store";

export enum NotificationType {
  Info = "info",
  Success = "success",
  Warn = "warning",
  Error = "error",
}

export class NotificationStore extends ChildStore {
  @observable
  public notifications: Notification[] = [];

  @observable
  public toast?: Notification;

  @observable
  public isToastOpen = false;

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this);
  }

  @computed
  get notificationCount() {
    return this.notifications.length;
  }

  @action
  push(message: string, tags: string[], type = NotificationType.Info) {
    const notification = new Notification(message, tags, type);
    this.notifications.push(notification);
    this.toast = notification;
    this.isToastOpen = true;
  }

  @action
  closeToast() {
    this.isToastOpen = false;
  }
}

class Notification {
  type: NotificationType;
  timestamp: DateTime;
  tags: string[];
  summary: string;
  message: string;

  constructor(message: string, tags: string[], type: NotificationType) {
    this.type = type;
    this.timestamp = DateTime.now();
    this.message = message;
    if (message.length > 20) {
      this.summary = `${message.substring(0, 20)}...`;
    } else {
      this.summary = message;
    }
    this.tags = tags;
  }
}
